import header from './atoms/header'
import '@splidejs/splide/css'
import Splide from '@splidejs/splide'

header()

document.addEventListener('DOMContentLoaded', e => { })

document.addEventListener('click', e => {
  if (e.target.classList.contains('testimony-filter')) {
    const targetFilter = e.target.dataset.target
    const testimonies = document.querySelectorAll(`.testimony:not(data-filter)`)
    if (targetFilter) {
      testimonies.forEach(testimony => {
        testimony.classList.toggle('is-hidden', !(testimony.dataset.filter === targetFilter));
      })
    } else {
      testimonies.forEach(testimony => {
        testimony.classList.remove('is-hidden')
      })
    }
  }
})
